import {Component, inject} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-exception-dialog',
  styleUrl: './exception-dialog.component.scss',
  imports: [
    TranslateModule,
    MatDialogModule,
    MatButton,
    MatIcon
  ],
  templateUrl: './exception-dialog.component.html'
})
export class ExceptionDialogComponent {
  protected data = inject(MAT_DIALOG_DATA);
}
